import { render, staticRenderFns } from "./MessageBoard.vue?vue&type=template&id=0c16f732&scoped=true"
import script from "./MessageBoard.vue?vue&type=script&lang=js"
export * from "./MessageBoard.vue?vue&type=script&lang=js"
import style0 from "./MessageBoard.vue?vue&type=style&index=0&id=0c16f732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16f732",
  null
  
)

export default component.exports